import { FormCheck } from './FormCheck.js';
import { scrollSummary } from './scrolls.js';
import moment from 'moment';
import * as intlTelInput from 'intl-tel-input';
import * as intlTelInputUtils from 'intl-tel-input/build/js/utils.js';
import { getAvailableHours, bindAdvisor, emptyAppointmentTime, getAdvisorMonthAvailableSummary } from './forms.js';
import { getDatepickerArrow, getLocaleJS } from '../js/main.js';
import { FormMapsSummary } from './FormMapsSummary.js';
import Actions from './Actions.js';
import { datesNoAvailablesSummary, maxDateAvailableSummary } from './forms.js';

var actions = new Actions();
var noAvailableDaysSummary = []
var slotDuration = $('#advisor_slot').val(); //By default
var minDateSummary = '';

export function getFirstDateSummary() {
    $.ajax({
        url: $('#url-base-lang').val()+$('#dealer').val()+"/"+"procesor/getFirstDate",
        data: 'pavh='+$('#dealer').val() + "&branch_id=" + $('#ws-id').val(),
        type: 'POST',
        beforeSend: function() {
            $('.loader-schedule-row .wrap-loader').show();
            $('.summarySchedule').hide();
        },
        success:function(result){	
            if(result!=='-1') {
                var data = JSON.parse(result);
                if(data.schedules) {
                    $.each(data.schedules, function(i,e) {
                        if(e.occupied==1 || e.occupied==2) {
                            let day = e.date.split(" ");
                            day = day[0];
                            day = moment(day,'DD/MM/YYYY').format('YYYY-MM-DD');
                            datesNoAvailablesSummary.push(day);
                        }
                    });
                }
                var firstAvailableDay = data.first_available_date;
                minDateSummary = firstAvailableDay;
                noWorkingDaysSummary();
            }
        }
    });
}

export function noWorkingDaysSummary(reload) {
    var arrayDays = $('#datetimePickerDateSummary tbody td.day');
    var start_date = $(arrayDays[0]).attr('data-day');
    var end_date = $(arrayDays[arrayDays.length - 1]).attr('data-day');
    start_date = moment(start_date, 'DD-MM-YYYY');
    end_date = moment(end_date, 'DD-MM-YYYY');
    start_date = moment(start_date, 'YYYY-MM-DD').unix();
    end_date = moment(end_date, 'YYYY-MM-DD').unix();

    var data = 'pavh='+$('#dealer').val();
    if($('#advisor_id').length>0) {
        data += '&advisor='+$('#advisor_id').val();
    }

    datesNoAvailablesSummary = [];
    noAvailableDaysSummary = []

    data += '&start='+start_date+'&end='+end_date+ "&branch_id=" + $('#ws-id').val();
    $.ajax({
        url: $('#url-base-lang').val()+$('#dealer').val()+"/"+"procesor/getNoWorkingDays",
        data: data,
        type:'POST',
        beforeSend: function() {
            $('.loader-schedule-row .wrap-loader').show();
            $('.summarySchedule').hide();
        },
        success:function(result){	
            let tempMinDate = moment.unix(minDateSummary).format("YYYY-MM-DD");
            $('#datetimePickerDateSummary').data('DateTimePicker').minDate(moment(tempMinDate));
            $('.loader-schedule-row .wrap-loader').hide();
            $('.summarySchedule').show();
            if(result!=='-1') {
                var data = JSON.parse(result);
                if(data.items) {
                    $.each(data.items, function(i,e) {
                        var day =  moment(e.day).format("YYYY-MM-DD");
                        datesNoAvailablesSummary.push(day);
                    });
                }
                if(data.non_weekly_working_days) {
                    $.each(data.non_weekly_working_days, function(i,e) {
                        let day =  moment(e.day).format("YYYY-MM-DD");
                        noAvailableDaysSummary.push(day);
                    });
                }

                // GET DAYS BY MONTH
                var day = $('#datetimePickerDateSummary').datetimepicker('viewDate');
                var month = day.format('M');
                var year  = day.format('YYYY');
                var dataUrl = 'pavh='+$('#dealer').val()+ "&branch_id=" + $('#ws-id').val() + "&month=" + month + "&year=" + year;
                if($('#appointment_advisor').length>0) {
                    dataUrl += '&advisor='+$('#advisor_id').val();
                }

                $.ajax({
                    url: $('#url-base-lang').val()+$('#dealer').val()+"/"+"procesor/getAdvisorMonthAvailable",
                    data: dataUrl,
                    type:'POST',
                    beforeSend: function() {
                        $('.hourPicker .wrap-loader').show();
                        $('#divSlotTable').hide();
                    },
                    success:function(result){	
                        $('.loader-schedule-row .wrap-loader').hide();
                        $('.scheduleBlock').css('display','flex');
                        if(result!=='-1') {
                            var data = JSON.parse(result);
                            if(data.schedules) {
                                $.each(data.schedules, function(i,e) {
                                    if(e.occupied==1 || e.occupied==2) {
                                        let day = e.date.split(" ");
                                        day = day[0];
                                        day = moment(day,'DD/MM/YYYY').format('YYYY-MM-DD');
                                        datesNoAvailablesSummary.push(day);
                                    }
                                });
                            }
                        }
    
                        var daySelected = '';
                        if(reload) {
                            $('#schedule_date').val('');
                            $('#schedule_hour').val('');
                            var hourSelected = '';
                            $('#default_schedule_time').val('');
                            restartDatepickerSummary(datesNoAvailablesSummary, noAvailableDaysSummary);
                            $('#datetimePickerDateSummary').data('DateTimePicker').date(moment().add(daysDelay, 'days'));
                            daySelected = $('#datetimePickerDateSummary').data('DateTimePicker').date();
                            emptyAppointmentTime();
                        } else {
                            restartDatepickerSummary(datesNoAvailablesSummary, noAvailableDaysSummary);
                            daySelected = $('#datetimePickerDateSummary').data('DateTimePicker').date();
                            if(!daySelected) {
                                daySelected = moment(new Date());
                            }
                            $('#schedule_date').val(daySelected.format("YYYY-MM-DD"));
                            if(!$('.summary').length>0){
                                $('#schedule_hour').val(daySelected.format("HH:mm"));
                            }
                            var hourSelected = daySelected.format("HH:mm");   
                        }

                        getAvailableHours(daySelected, hourSelected, slotDuration, true);
                    }
                }) 
            } 
        }
    });   
}

export function repaintCalendarSummary(datesNoAvailablesSummary, maxDateAvailable) {
    var arrayDays = $('#datetimePickerDateSummary tbody td.day');
    $(arrayDays).removeClass('disabled'); 
    let timeFormatDay = $('#dateTimePattern').val();

    var maxDateFormat = '';
    if(maxDateAvailable && maxDateAvailable != '') {
        var maxDateFormat = moment(moment.unix(maxDateAvailable)).format(timeFormatDay);
        maxDateFormat = maxDateFormat.split(' ');
    }

    $.each(datesNoAvailablesSummary, function(i, e) {     
        for(var i = 0; i < arrayDays.length; i += 1) {
            //Deshabilitem els dies concrets retornats per el mètode
            var day = moment(e).format(timeFormatDay);
            day = day.split(' ');
            if (($(arrayDays[i]).attr('data-day') === day[0]) && (!$(arrayDays[i]).hasClass('disabled'))){
                $(arrayDays[i]).addClass('disabled');
            }
            if(maxDateAvailable && maxDateAvailable != '') {
                if(moment($(arrayDays[i]).attr('data-day'),timeFormatDay).isAfter(moment(maxDateFormat,timeFormatDay))
                || moment($(arrayDays[i]).attr('data-day'),timeFormatDay).isSame(moment(maxDateFormat,timeFormatDay).startOf('day'))) {
                    $(arrayDays[i]).addClass('disabled');
                }
            }
        }
    });
}

var datepickerScheduleSummary = null;
var daysDelay = parseInt($('#date-delay').val()) +1;
var userLang = navigator.language || navigator.userLanguage; 
var arrows = getDatepickerArrow($('#lang').val());
var defaultDate =  $('#default_schedule_time').val();
var actualDate = moment(new Date()).format("YYYY-MM-DD");
if(defaultDate<actualDate) {
    defaultDate = moment(new Date()).format("YYYY-MM-DD");
}
// var minDate = moment().add(daysDelay,'days').format("YYYY-MM-DD");

// if((noAvailableDaysSummary.indexOf(minDate) > -1)>0) {
//     minDate = moment().add(daysDelay +1,'days').format("YYYY-MM-DD");
// }
// if(new Date(minDate).getDay() == 0) {
//     minDate = moment().add(daysDelay +1,'days').format("YYYY-MM-DD");
// }

if(defaultDate<minDateSummary) {
    defaultDate = minDateSummary;
}

datepickerScheduleSummary = $('#datetimePickerDateSummary').datetimepicker({
    useCurrent: false,
    inline: true,
    sideBySide: false,
    collapse: false,
    format: 'L',
    dayViewHeaderFormat: "MMMM YYYY",
    locale: getLocaleJS(lang),
    defaultDate: defaultDate,
    icons: {
        previous: arrows.previous,
        next: arrows.next
    }
});

datepickerScheduleSummary.on("dp.change", function (e) {
    slotDuration = $('#advisor_slot').val(); //By default
    var daySelected = $('#datetimePickerDateSummary').data('DateTimePicker').date();
    $('#schedule_date').val(daySelected.format("YYYY-MM-DD"));
    getAvailableHours(daySelected, null, slotDuration, false);
    repaintCalendarSummary(datesNoAvailablesSummary, maxDateAvailableSummary)
});

datepickerScheduleSummary.on("dp.update", function (e) {
    var currentView = $('#datetimePickerDateSummary').data('DateTimePicker').viewDate();
    var firstDay = moment(currentView, 'DD-MM-YYYY').startOf('month');
    let tempMinDate = moment.unix(minDateSummary).format("YYYY-MM-DD");
    if(firstDay.isSame(moment(defaultDate), 'month') && firstDay.isSame(moment(defaultDate), 'month')) {
        $('#datetimePickerDateSummary').data('DateTimePicker').date(moment(defaultDate));
    } else if(firstDay.isBefore(moment(tempMinDate))) {
        let tempMinDate = moment.unix(minDateSummary).format("YYYY-MM-DD")
        $('#datetimePickerDateSummary').data('DateTimePicker').date(moment(tempMinDate));
    } else {
        $('#datetimePickerDateSummary').data('DateTimePicker').date(firstDay);
    } 

    getAdvisorMonthAvailableSummary();
});

export function restartDatepickerSummary(datesNoAvailablesSummary, noAvailableDaysSummary) {
    var arrayDays = $('#datetimePickerDateSummary tbody td.day');
    if(datesNoAvailablesSummary) {
        $.each(datesNoAvailablesSummary, function(i, e){	
            for(var i = 0; i < arrayDays.length; i += 1) {
                var day = moment($(arrayDays[i]).attr('data-day'), 'DD-MM-YYYY').format('YYYY-MM-DD');
                if((day === e) && (!$(arrayDays[i]).hasClass('disabled'))){
                    $(arrayDays[i]).addClass('disabled');
                }
            }
        });
    }
    if(noAvailableDaysSummary) {
        $.each(noAvailableDaysSummary, function(i, e) {
            for(var i = 0; i < arrayDays.length; i += 1) {
                var day = moment($(arrayDays[i]).attr('data-day'), 'DD-MM-YYYY').format('YYYY-MM-DD');
                if ((day === e) && (!$(arrayDays[i]).hasClass('disabled'))){
                    $(arrayDays[i]).addClass('disabled');
                }
            }
        });
    }    
    $('#datetimePickerDateSummary tbody td.day.active').addClass('disabled');         
}

$(function() {
	$('.summary #appointment_vehicle_brand').select2({
		width: '100%'
	});
	$('.summary #appointment_vehicle_model').select2({
		width: '100%'
    });

    //what do we need to show at start
    if ($('#default_model_name').val() != '') { // hi ha model name
        $('.summary .vehicle_select_box').hide();
        $('.summary .vehicle_insert_box').show();
        $('.summary #appointment_vehicle_brand').val($('#default_brand').val()).trigger("change",[{data: ""}]);
        $('.summary #appointment_vehicle_model_name').val($('#default_model_name').val());
    } else {
        $('.summary #appointment_vehicle_brand').val($('#default_brand').val()).trigger("change");
    }

    if($('#advisor_count').val() == 0 && $('#appointment_advisor_summary').length>0) {
        $('#error-advisor').show();
        $('#error-advisor').find('.error').addClass('d-block');
        $('#error-advisor').find('.error-msg').html(errorsTranslations['workshop_no_advisor']);
        $('#appointment-summary-continue').prop('disabled', true);
    }

    //bind by default!
    bindAdvisor();

    $('#collapse-summary-reason #reason-comments-desktop, #collapse-summary-reason #reason-discount-codes-desktop').show();
 
    $('#appointment-summary-continue').on('click', function() {
        $('#summary-vehicle .error-row').removeClass('d-block');
        $('#summary-vehicle #error-vehicle').find('.error').removeClass('d-block');
        $('#summary-customer #error-datos').find('.error').removeClass('d-block');
        $('#summary-customer #error-datos').find('.error-msg').html('');
        $('#summary-vehicle #error-vehicle').find('.error-msg').html('');
        $('#summary-reason #error-reason').find('.error').removeClass('d-block');
        $('#summary-reason #error-reason').find('.error-msg').html('');
        $('#appointment_reason_msg').parent().removeClass('has-error');

        $('.iti--allow-dropdown').removeClass('has-error');

        var formCheck = new FormCheck();
        var errors = '';
        $('.submit-msg-ok').hide();
        $('.submit-msg-fail').hide();
        removeErrors('#summary-vehicle',formCheck.errorClass);
        removeErrors('#summary-customer',formCheck.errorClass);
        formCheck.checkParams(['checkScript', 'checkPlate', 'checkMandatory'], '#appointment_vehicle_plate');
        formCheck.checkParams(['checkScript', 'checkNoSymbols'], '#appointment_vehicle_kms');
        formCheck.checkParams(['checkScript', 'checkNoSymbols', 'checkNum'], '#appointment_model_year');
        if($('.vehicle_insert_box').css('display') !== 'none'){
            formCheck.checkParams(['checkMandatory','checkScript', 'checkNoSymbols'], '#appointment_vehicle_model_name');
        } 

        var totalErrorMsg = formCheck.getMsgError();  
        if(totalErrorMsg.length > 0) {
            errors += "<ul>";
            totalErrorMsg.forEach(function(e){
                errors += '<li>'+e.error+": <i>"+e.fields+'</i></li>';
            });
            errors += '</ul>';
            $('#summary-vehicle .error-row').addClass('d-block');
            $('#summary-vehicle #error-vehicle').find('.error').addClass('d-block');
            $('#summary-vehicle #error-vehicle').find('.error-msg').html(errors);
            scrollSummary("#summary-vehicle");
        } else {
            formCheck.checkParams(['checkScript', 'checkOnlyWhiteSpaces'], '#appointment_reason_msg');
            totalErrorMsg = formCheck.getMsgError();  
            if(totalErrorMsg.length > 0) {
                errors += "<ul>";
                totalErrorMsg.forEach(function(e){
                    errors += '<li>'+e.error+": <i>"+e.fields+'</i></li>';
                });
                errors += '</ul>';
                $('#collapse-summary-reason').addClass("show");
                $('#summary-reason #reason-comments-desktop .error-row').addClass('d-block');
                $('#summary-reason #error-reason').find('.error').addClass('d-block');

                $('#summary-reason #error-reason').find('.error-msg').html(errors);
                scrollSummary("#collapse-summary-reason");
            } else {
                var accountType = $('#account_type').val();
                var clientType = $('#client_type').val();
                if (clientType == null) {
                    clientType = 0;
                }

                if(accountType == '12') {
                    formCheck.checkParams(['checkMandatory','checkOnlyWhiteSpaces', 'checkScript', 'checkNoSymbols'], '#appointment_name'); 
                    if (clientType == 0)  {
                        formCheck.checkParams(['checkMandatory','checkScript', 'checkNoSymbols'], '#appointment_surname');
                        if (country_code != 'GB') {
                            formCheck.checkParams(['checkMandatory','checkOnlyWhiteSpaces', 'checkScript', 'checkNoSymbols'], '#appointment_surname_second');
                        }
                    }
                    if (country_code != 'GB') {
                        formCheck.checkParams(['checkMandatory', 'checkOnlyWhiteSpaces', 'checkScript', 'checkNoSymbols', 'checkAcentos'], '#appointment_dni');
                        if ($('#appointment_dni').val() != '')
                            formCheck.checkParamsDNI($('#country-code').val(),clientType);

                        formCheck.checkParams(['checkMandatory','checkPhone'], '#appointment_tlf');  
                        formCheck.checkParams(['checkMandatory','checkScript', 'checkMail'], '#appointment_mail');
                    }
                    
                    if($('#appointment_tlf').val()!='') {
                        if(!verifyTelf('#appointment_tlf')) {
                        formCheck.insertError('#appointment_tlf', errorsTranslations['SMS_PROVIDER_ERROR:02029_PHONE_NUMBER_INVALID_FORMAT']);
                        }
                        else {
                            formCheck.checkParams(['checkPhone'], '#appointment_tlf');  
                        }   
                    }
                } else {
                    if (clientType == 1) {
                        formCheck.checkParams(['checkMandatory', 'checkOnlyWhiteSpaces', 'checkScript', 'checkNoSymbols'], '#appointment_name');  
                    } else {
                        if($('#appointment_name').length>0) {
                            formCheck.checkParams(['checkOnlyWhiteSpaces', 'checkScript', 'checkNoSymbols'], '#appointment_name');  
                        }
                        formCheck.checkParams(['checkMandatory','checkScript', 'checkNoSymbols'], '#appointment_surname');  

                        if($('#appointment_surname_second').length>0 && country_code != 'GB') {
                            formCheck.checkParams(['checkOnlyWhiteSpaces', 'checkScript', 'checkNoSymbols'], '#appointment_surname_second');  
                        }
                    }

                    if (country_code != 'GB') {
                        formCheck.checkParams(['checkOnlyWhiteSpaces', 'checkScript', 'checkNoSymbols', 'checkAcentos'], '#appointment_dni');
                        if ($('#appointment_dni').val() != '')
                            formCheck.checkParamsDNI($('#country-code').val(), clientType);
                    }

                    //first mirar si email sino telf
                    if($('#appointment_tlf').val()!='') {
                        if(!verifyTelf('#appointment_tlf')) {
                        formCheck.insertError('#appointment_tlf', errorsTranslations['SMS_PROVIDER_ERROR:02029_PHONE_NUMBER_INVALID_FORMAT']);
                        }
                        else {
                            formCheck.checkParams(['checkPhone'], '#appointment_tlf');  
                        }   
                    }
                    if($('#appointment_mail').length>0) {
                        formCheck.checkParams(['checkScript', 'checkMail'], '#appointment_mail');  
                    }
                    if($('#appointment_mail').val()==='' && $('#appointment_tlf').val()==='') {
                        formCheck.checkMultiple(['#appointment_mail', '#appointment_tlf'], errorsTranslations['MAIL_TLF_MANDATORY']);
                    } 
                }  
                            
                totalErrorMsg = formCheck.getMsgError();  

                if (totalErrorMsg.length > 0) {
                    errors += "<ul>";
                    totalErrorMsg.forEach(function(e){
                        errors += '<li>'+e.error+": <i>"+e.fields+'</i></li>';
                    });
                    errors += '</ul>';
                    $('#summary-customer #error-datos').find('.error').addClass('d-block');
                    $('#summary-customer #error-datos').find('.error-msg').html(errors);
                    scrollSummary("#summary-customer");
                } else {
                    if($('#advisor_id').val()=='') {
                        $('#error-advisor').show();
                        $('#error-advisor').find('.error').addClass('d-block');
                        $('#error-advisor').find('.error-msg').html(errorsTranslations['advisor_is_mandatory']);
                    }
                    else if($('#schedule_date').val()=='' || $('#schedule_hour').val()=='') {
                        $('#error-schedule').show();
                        $('#error-schedule .error').show();
                        $('#error-schedule').find('.error-msg').html(errorsTranslations['schedule_title']);
                    } 
                    else {
                        $('.summary-reason .error .error-msg').html("");
                        $('.summary-reason .error').hide();
                        $('.summary-reason #error-reason').hide();
                        var newDate = Date.parse($('#schedule_date').val() + "T" + $('#schedule_hour').val()+ "Z");
                        newDate= newDate/1000;
                        var replacement_vehicle = ($('#appointment-replace-vehicle').is(':checked')) ? 1 : 0;

                        var model = "";
                        if($('.vehicle_insert_box').css('display') !== 'none') {
                            model = "&model="+$('#appointment_vehicle_model_name').val()+"&model_id="+"";
                        }
                        else {
                            model = "&model_id="+$('#appointment_vehicle_model').val();
                        }

                        var clientType = $('#client_type').val();
                        if (clientType == null) {
                            clientType = 0;
                        }
                        
                        var data = "type=0" +
                        "&comments="+$('#appointment_reason_msg').val()+
                        "&plate="+$('#appointment_vehicle_plate').val().toUpperCase()+
                        "&brand_id="+$('#appointment_vehicle_brand').val()+
                        model +
                        "&model_year="+$('#appointment_model_year').val()+
                        "&client_type="+ clientType +
                        "&firstname="+$('#appointment_name').val();

                        if (clientType == 0) {
                            data += "&lastname="+$('#appointment_surname').val()+
                            "&secondlastname="+(country_code != 'GB' ? $('#appointment_surname_second').val() : '');
                        }
                        data += "&vat_number="+(country_code != 'GB' ? $('#appointment_dni').val() : '')+
                        "&mobile="+encodeURIComponent(itiClientSummary.getNumber())+
                        "&mail="+$('#appointment_mail').val()+
                        "&kms="+$('#appointment_vehicle_kms').val()+
                        "&replacement_vehicle="+replacement_vehicle+
                        "&branch_id="+$('#ws-id').val()+
                        "&pavh="+$('#dealer').val() +
                        "&id="+$('#appointment_id').val();

                        if($('#advisor_id').length>0 && $('#advisor_id').val()!='') {
                            data += "&advisor_id="+$('#advisor_id').val()
                        }

                        if($('#schedule_date').length>0) {
                            data += "&start_date="+newDate;
                        }

                        if($('#account_type').length>0 && $('#account_type').val() == 12) {
                            data += "&quotation=1";
                        }

                        if ($('.code-tag').length > 0) {
                            var discount_codes = [];
                            $('.code-tag').each(function(i,l){
                                discount_codes.push({code:$(l).attr('data-value')});
                            });
                            data += "&discount_codes="+encodeURIComponent(JSON.stringify(discount_codes));
                        }

                        $.ajax({
                            url: $('#url-base-lang').val()+$('#dealer').val()+"/form/update",
                            data: data,
                            type: 'POST',
                            beforeSend: function() {
                                $('#appointment-summary-continue').prop('disabled', true);
                            },
                            success: function(result) {
                                if(result!='-1') {
                                    var IS_JSON = true;
                                    try{
                                        var obj = JSON.parse(result);
                                    }catch(err){
                                        IS_JSON = false;
                                    } 
                                    if(IS_JSON){
                                        $('#appointment-summary-continue').prop('disabled', false);
                                        if(obj.found == "true") {
                                            $('.submit-msg-ok').show();
                                            location.href = $('#url-base-lang').val()+$('#dealer').val()+"/form/"+$('#hash').val();
                                        }
                                        else {
                                            $('.submit-msg-fail').show();
                                        }
                                    }
                                }
                            }
                        });
                    }
                }
            } 
        }
    });

    function removeErrors(section, error) {
        $(section).find('.error').removeClass('d-block');
        $(section).find('.error-msg').html('');
        $(section).find('.form-group').each(function() {
            $(this).removeClass(error);
        }); 
    }

    $('#summary-cancel-changes').on('click', function() {
        location.href = $('#url-base-lang').val()+$('#dealer').val()+"/form/"+$('#hash').val();        //location.reload();
    });

    $('#collapsescheduleBlock').on('show.bs.collapse', function () {
        if(!$('#collapsescheduleBlock').is(':visible')) {
            getAdvisorMonthAvailableSummary();
        }
    });

     //PHONE NUMBER
     var iti = null; // deprecated
     var itiClientSummary = null;
     var currentCountry = 'es'; //default
     var onlyCountries = [currentCountry];
     if($('.summary').length>0) {
        if($('#country-code').length>0 && $('#country-code').val()!='') {
            currentCountry = $('#country-code').val();
            itiClientSummary = intlTelInput(document.querySelector("#appointment_tlf"), {
                initialCountry: currentCountry,
                nationalMode: true,
                autoPlaceholder: "off",
                utilsScript: "../../build/js/utils.js"
            });
        } else {
            // call endpoint
            $.getJSON('https://extreme-ip-lookup.com/json/')
            .done(function(data) {
                currentCountry = data.countryCode.toLowerCase();
                onlyCountries.push(currentCountry);
                itiClientSummary = intlTelInput(document.querySelector("#appointment_tlf"), {
                    initialCountry: currentCountry,
                    nationalMode: true,
                    autoPlaceholder: "off",
                    utilsScript: "../../build/js/utils.js"
                });
            })
            .fail(function() {
                itiClientSummary = intlTelInput(document.querySelector("#appointment_tlf"), {
                    initialCountry: currentCountry,
                    nationalMode: true,
                    autoPlaceholder: "off",
                    utilsScript: "../../build/js/utils.js"
                });
            });  
        }
    }   

    function verifyTelf(telf) {
        var input = document.querySelector(telf);
        if (input.value.trim()) {
            if(itiClientSummary.isValidNumber()) {
                return true;
            } 
            return false;
        }
    }

    // triggers
    var somethingChanged = false;
    $('#datetimepickerModelYear').on("dp.update", function (e) {
        if($('.summary').length>0) {
            somethingChanged = true;
            $('#summary-cancel-changes').show();
        }
    });

    $('.summary input, .summary textarea, .summary select#appointment_vehicle_brand').on('change keypress', function() {
        somethingChanged = true;
        $('#summary-cancel-changes').show();
    });

    var firstLoadModel = false;
    $('.summary select#appointment_vehicle_model').on('change', function() {
        if(firstLoadModel) {
            $('#summary-cancel-changes').show();
        }
        firstLoadModel = true;
    });
    
    

    function phoneInputBranches(element) {
        iti = intlTelInput(document.querySelector(element), {
            nationalMode: true,
            autoPlaceholder: "off",
            utilsScript: "../../build/js/utils.js"
        });
    }

    var formMapsSummary = new FormMapsSummary();
    if($('.summary-block').length>0) {
        $('.wf-list-block .mobile-field').each(function(element) {
            phoneInputBranches('#'+$(this).attr('id'));
        });
        if($('.multiple-summary-branch').length>0) {
            formMapsSummary.getBranches();
        }
    }

    $('#modalDelete .btn-cancel').on('click', function() {
        var data = "pavh="+$('#dealer').val() + "&id="+ $('#appointment_id').val();
        if($('#account_type').length>0 && $('#account_type').val() == 12) {
            data += "&quotation=1";
        }

        $.ajax({
            url: $('#url-base-lang').val()+$('#dealer').val()+"/form/delete",
            data: data,
            type: 'POST',
            beforeSend: function() {
                $('#appointment-summary-continue').prop('disabled', true);
                $('#modalDelete .btn-cancel').prop('disabled', true);
                $('#modalDelete .btn-cancel .fa-circle-notch').show();
            },
            success: function(result) {
                if(result!='-1') {
                    var IS_JSON = true;
                    try{
                        var obj = JSON.parse(result);
                    }catch(err){ 
                        IS_JSON = false;
                    } 
                    if(IS_JSON){
                        $('#appointment-summary-continue').prop('disabled', false);
                        $('#modalDelete .btn-cancel').prop('disabled', false);
                        $('#modalDelete .btn-cancel .fa-circle-notch').hide();
                        if(obj.found == "true") {
                            location.href = $('#url-base-lang').val()+$('#dealer').val()+"/cancel";
                        }
                    }
                }
            }
        });
    });

    //Binding new categories
    if($('.summary').length>0) {
        var firstId = "";
        //open first category with actions -> >4 actions
        if($('.no-swiper-container').length>0) {
            if($('.no-swiper-container .form-icon-btn-padding .form-btn-icons .type-selected').length>0) {
                var first = $('.no-swiper-container .form-icon-btn-padding .form-btn-icons .type-selected')[0];
                firstId = $(first).parent().attr('data');
                $('#category-caret-'+firstId).show();
                $('#category-actions-container-'+firstId).show();
                $(first).addClass('form-icon-content-no-radius');
                $(first).addClass('form-icon-content-no-bottom');
                $('.form-icon-btn-padding #category-caret-'+firstId).addClass('category-caret-active');
            }           
        } else if($('.swiper-summary').length>0) {
            if($('.swiper-summary .form-icon-btn-padding .form-icon-content.type-selected').length>0) {
                var first = $('.swiper-summary .form-icon-btn-padding .form-icon-content.type-selected')[0];
                firstId = $(first).parent().attr('data');
                $('#category-caret-'+firstId).show();
                $('#category-actions-container-'+firstId).show();
                $(first).addClass('form-icon-content-no-radius');
                $(first).addClass('form-icon-content-no-bottom');
                $('.form-icon-btn-padding #category-caret-'+firstId).addClass('category-caret-active');
            }
        }
        actions.showActionBox(firstId);
        // show actions block
        $('#collapseReasonMsg').show();
    }
});